import React, { useState, useEffect } from 'react';
import { Switch } from '@mui/material';

function SwitchPubLab(props) {
    const [isSwitched, setIsSwitched] = useState(false);
    const [newStatus, setNewStatus] = useState();

    const toggleEnabled = () => {
        setIsSwitched(!isSwitched);
        setNewStatus(!isSwitched ? "on" : "off");
    };

    useEffect(() => {
        if (newStatus) {
            setTimeout(async () => {
                await fetch(process.env.REACT_APP_URL_SWITCH_PUB_STATUS_LAB +
                    '?id=' + props.idLab +
                    '&status=' + newStatus
                    , {
                        credentials: 'include',
                        method: "GET"
                    })
                    .then((resp) => resp.json())
                    .then((data) => {
                        console.log(data.idLab + " updated! " + data.registerUrlStatus);
                    })
                    .catch((error) => {
                        console.log(error, "Errore!");
                    });
            });
        }
    }, [props.idLab, isSwitched, newStatus]);

    useEffect(() => {
        if (props.registerUrlStatus)
            setIsSwitched(props.registerUrlStatus !== "off");
    }, [props.registerUrlStatus]);

    return (
        <Switch
            id={props.idLab}
            checked={isSwitched}
            onChange={toggleEnabled}
            sx={{
                '& .MuiSwitch-switchBase.Mui-checked': {
                    color: '#a71e3b',
                },
                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                    backgroundColor: '#a71e3b',
                },
            }}
        />
    );
}

export default SwitchPubLab;
